module.exports = __webpack_public_path__ + "img/電気回路_2_6.45dba744.png";